export default function (inches) {
  if (parseFloat(inches) <= 1.0) {
    return 'inch';
  } return 'inches';
}
